import { render, staticRenderFns } from "./PublicFilesView.vue?vue&type=template&id=03ef8c08&scoped=true&"
import script from "./PublicFilesView.vue?vue&type=script&lang=js&"
export * from "./PublicFilesView.vue?vue&type=script&lang=js&"
import style0 from "./PublicFilesView.vue?vue&type=style&index=0&id=03ef8c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ef8c08",
  null
  
)

export default component.exports